export default "__VITE_ASSET__B62DCqj$__"